var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 236,
    viewBox: "0 0 322 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.347 180.81C195.897 166.297 193.429 151.344 186.349 138.418L179.245 125.422L305.705 56.2662L312.799 69.2779C316.899 76.7798 319.484 85.0163 320.404 93.5167C321.325 102.017 320.564 110.615 318.164 118.818C315.765 127.022 311.775 134.67 306.421 141.326C301.068 147.982 294.456 153.516 286.964 157.61L160.576 226.737C169.138 222.046 176.532 215.48 182.206 207.528C187.88 199.576 191.688 190.444 193.347 180.81Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.346 180.81C191.042 194.108 184.663 206.357 175.094 215.857C165.524 225.358 153.239 231.64 139.94 233.834C126.642 236.027 112.988 234.023 100.872 228.1C88.7556 222.176 78.777 212.626 72.3189 200.773L1 70.1402L127.45 1.00006L191.674 118.621L179.245 125.421L186.349 138.418C193.428 151.343 195.897 166.297 193.346 180.81Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.964 157.61C294.451 153.516 301.06 147.985 306.411 141.332C311.762 134.678 315.751 127.034 318.151 118.835C320.551 110.636 321.314 102.043 320.397 93.5458C319.48 85.049 316.901 76.8152 312.807 69.3145L305.713 56.3028L179.253 125.458L186.357 138.455C190.451 145.956 193.029 154.189 193.946 162.686C194.863 171.183 194.099 179.776 191.699 187.975C186.853 204.533 175.635 218.481 160.514 226.75C153.027 230.844 144.806 233.421 136.322 234.333C127.838 235.245 119.257 234.475 111.068 232.066C94.5301 227.202 80.5946 215.958 72.3273 200.81L1 70.1402L127.45 1L191.675 118.621",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.955 157.573L160.505 226.713",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 90.5098L108.987 54.261",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6221 117.315L96.7493 96.1258",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7197 144.544L148.459 103.014",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.291 172.604L146.933 140.568",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.197 198.818L150.515 175.303",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.11 209.842L193.347 180.809L194.065 180.412",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.dfd40e9c41f819fcafc877f14057eef4.svg";
export { ForwardRef as ReactComponent };